var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VAppLayout',{attrs:{"has-header":"","has-footer":""}},[_c('VAppHeader'),_c('VAppMain',[_c('div',{staticClass:"home-services__wrapper"},[_c('HomeServicesTiles')],1)]),_c('VAppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }